import React, { useEffect, useState } from 'react'
import Button from '../../../../../components/molecules/Button/Button'
import { useSingleSpendingDemand } from '../../../hooks'
import useUserAuth from '../../../../auth/hook/useUserAuth'
import useNavigationApp from '../../../../../navigation/hook/useNavigationApp'
import SuccessMessage, { SuccessMessageType } from '../../../../../components/atoms/SuccessMessage/SuccessMessage'

export default function CancelBtnUser() {

  const {sendCancelSpendingDemand, singleSpendingDemandData} = useSingleSpendingDemand()

  const {userInfo} = useUserAuth()

  const handleCancel = () => {
    sendCancelSpendingDemand.run({message: "Demande annulée"})
  }

  if(sendCancelSpendingDemand.isPending){
    return <p>Annulation en cours</p>
  }


  if (!userInfo?.user_id) {
    return <></>
  }

  if (!singleSpendingDemandData) {
    return <></>
  }

  if (userInfo?.user_id !== singleSpendingDemandData?.spending_demand_user?.user_id) {
    return <></>
  }

  if (singleSpendingDemandData?.spending_demand_status === "CANCELLED") {
    return <></>
  }

  if (singleSpendingDemandData?.spending_demand_status === "VALIDATE" || singleSpendingDemandData?.spending_demand_status === "REFUSED" || singleSpendingDemandData?.spending_demand_status === "PAYED") {
    return <></>
  }

  return (
    <div>
          <Button
            label="Annuler"
            onClick={handleCancel}
            disabled={sendCancelSpendingDemand.isPending}
            style="red" //eslint-disable-line
          />
    </div>
  )
}


export const ModifySpendingDemandBtnUser = () => {

  const {singleSpendingDemandData} = useSingleSpendingDemand()

  const {userInfo} = useUserAuth()

  if (!singleSpendingDemandData) {
    return <></>
  }

  if (singleSpendingDemandData?.spending_demand_status !== "WAITING_UPDATE") {
    return <></>
  }

  if (singleSpendingDemandData?.spending_demand_user?.user_id !== userInfo?.user_id) {
    return <></>
  }


  if (!singleSpendingDemandData) {
    return <></>
  }



  return (
    <div>
      <Button label="Corriger"

        linkTo={`/spending_demand/${singleSpendingDemandData?.spending_demand_id}/update`}
        style="primary" //eslint-disable-line
      />
    </div>
  )
}

export const SetPayedBtnUser = () => {

  const {singleSpendingDemandData, setPayedSingleSpending} = useSingleSpendingDemand()



  if (!singleSpendingDemandData) {
    return <></>
  }

  
  if (singleSpendingDemandData?.spending_demand_status !== "VALIDATE"  &&
    singleSpendingDemandData?.spending_demand_status !== "CREDITED" 
  ) {
    return <></>
  }

  return <Button label="Déclarer payé" onClick={() => setPayedSingleSpending.run({})} style="green" /> //eslint-disable-line
}

export const CloseSpendingDemandBtnUser = () => {

  const {singleSpendingDemandData, setCloseSingleSpending} = useSingleSpendingDemand()
  const [successMessage, setSuccessMessage] = useState<{
    type: SuccessMessageType;
    isVisible: boolean;
  }>({
    type: 'cloture',
    isVisible: false,
  });
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (setCloseSingleSpending.isSucess) {
      setSuccessMessage({
        type: 'cloture',
        isVisible: true,
      });
      setErrorMessage(null);
      
      // Hide the message after 3 seconds
      const timer = setTimeout(() => {
        setSuccessMessage(prev => ({ ...prev, isVisible: false }));
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [setCloseSingleSpending.isSucess]);

  useEffect(() => {
    if (setCloseSingleSpending.isError) {
      setErrorMessage("Une erreur est survenue lors de la clôture de la demande");
      setSuccessMessage({ type: 'cloture', isVisible: false });
      
      // Hide the error message after 5 seconds
      const timer = setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [setCloseSingleSpending.isError]);

  if (!singleSpendingDemandData) {
    return <></>
  }

  if (singleSpendingDemandData?.spending_demand_status === "CLOSED" || singleSpendingDemandData?.spending_demand_status === "PAYED") {
    return <></>
  }

  // Show success message if visible
  if (successMessage.isVisible) {
    return (
      <SuccessMessage 
        type={successMessage.type} 
        isVisible={successMessage.isVisible} 
      />
    );
  }

  return (
    <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
      <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
        <Button 
          label="Cloturer la demande de dépense" 
          onClick={() => setCloseSingleSpending.run({})} 
          style="green" //eslint-disable-line
          disabled={setCloseSingleSpending.isPending}
        />
        {setCloseSingleSpending.isPending && <p style={{margin: 0}}>Clôture en cours...</p>}
      </div>
      {errorMessage && (
        <div style={{ 
          color: '#d32f2f', 
          backgroundColor: '#ffebee', 
          padding: '12px', 
          borderRadius: '4px',
          fontSize: '14px',
          border: '1px solid #ffcdd2'
        }}>
          {errorMessage}
        </div>
      )}
    </div>
  )
}

export const CreateSpendingFromSpendingDemandBtnUser = () => {

  const {singleSpendingDemandData} = useSingleSpendingDemand()
  const {goToCreateSpendingFromDemand} = useNavigationApp()


  if (singleSpendingDemandData?.spending_demand_status !== "VALIDATE"  &&
    singleSpendingDemandData?.spending_demand_status !== "CREDITED" 
  ) {
    return <></>
  }

  if (!singleSpendingDemandData) {
    return <></>
  }

  const handleNavigateToCreateSpending = () => {
    if (singleSpendingDemandData?.spending_demand_id) {
      goToCreateSpendingFromDemand(
        singleSpendingDemandData.spending_demand_id,
        singleSpendingDemandData.spending_demand_desc,
        singleSpendingDemandData.spending_demand_amount,
        singleSpendingDemandData.spending_demand_amountTTC,
        singleSpendingDemandData.spending_demand_desc
      )
    }
  }

  return (
    <div>
      <Button 
        label="Créer une dépense"
        onClick={handleNavigateToCreateSpending}
        style="gray" //eslint-disable-line
      />
    </div>
  )
}

export const CreateCreditFromSpendingDemandBtnUser = () => {

  const {singleSpendingDemandData} = useSingleSpendingDemand()
  const {goToCreateCreditFromDemand} = useNavigationApp()


  if (singleSpendingDemandData?.spending_demand_status !== "VALIDATE" &&
      singleSpendingDemandData?.spending_demand_status !== "CREDITED" 
    ) {
    return <></>
  }

  if (!singleSpendingDemandData) {
    return <></>
  }

  const handleNavigateToCreateCredit = () => {
    if (singleSpendingDemandData?.spending_demand_id) {
      goToCreateCreditFromDemand(
        singleSpendingDemandData.spending_demand_id,
        singleSpendingDemandData.spending_demand_desc,
        singleSpendingDemandData.spending_demand_user?.user_id
      )
    }
  }

  return (
    <div>
      <Button 
        label="Créer une avance"
        onClick={handleNavigateToCreateCredit}
        style="gray" //eslint-disable-line
      />
    </div>
  )
}

/**
 * ActionComptaUser - Groupe de boutons pour les actions comptables
 * Affiche uniquement si le statut est VALIDATE ou CREDITED
 * Contient: Cloturer la demande, Créer une dépense, Créer une avance
 */
export const ActionComptaUser = () => {
  const {singleSpendingDemandData, setCloseSingleSpending} = useSingleSpendingDemand()
  const {goToCreateSpendingFromDemand, goToCreateCreditFromDemand} = useNavigationApp()
  const {isComptable} = useUserAuth()
  const [successMessage, setSuccessMessage] = useState<{
    type: SuccessMessageType;
    isVisible: boolean;
  }>({
    type: 'cloture',
    isVisible: false,
  });
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (setCloseSingleSpending.isSucess) {
      setSuccessMessage({
        type: 'cloture',
        isVisible: true,
      });
      setErrorMessage(null);
      
      // Hide the message after 3 seconds
      const timer = setTimeout(() => {
        setSuccessMessage(prev => ({ ...prev, isVisible: false }));
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [setCloseSingleSpending.isSucess]);

  useEffect(() => {
    if (setCloseSingleSpending.isError) {
      setErrorMessage("Une erreur est survenue lors de la clôture de la demande");
      setSuccessMessage({ type: 'cloture', isVisible: false });
      
      // Hide the error message after 5 seconds
      const timer = setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [setCloseSingleSpending.isError]);

  if (!singleSpendingDemandData) {
    return <></>
  }

  // Ne s'affiche que si le statut est VALIDATE ou CREDITED
  if (singleSpendingDemandData?.spending_demand_status !== "VALIDATE" &&
      singleSpendingDemandData?.spending_demand_status !== "CREDITED") {
    return <></>
  }

  const handleClose = () => {
    setCloseSingleSpending.run({})
  }

  // Show success message if visible
  if (successMessage.isVisible) {
    return (
      <SuccessMessage 
        type={successMessage.type} 
        isVisible={successMessage.isVisible} 
      />
    );
  }

  const handleNavigateToCreateSpending = () => {
    if (singleSpendingDemandData?.spending_demand_id) {
      goToCreateSpendingFromDemand(
        singleSpendingDemandData.spending_demand_id,
        singleSpendingDemandData.spending_demand_desc,
        singleSpendingDemandData.spending_demand_amount,
        singleSpendingDemandData.spending_demand_amountTTC,
        singleSpendingDemandData.spending_demand_desc
      )
    }
  }

  const handleNavigateToCreateCredit = () => {
    if (singleSpendingDemandData?.spending_demand_id) {
      goToCreateCreditFromDemand(
        singleSpendingDemandData.spending_demand_id,
        singleSpendingDemandData.spending_demand_desc,
        singleSpendingDemandData.spending_demand_user?.user_id
      )
    }
  }



  return (
    <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
      <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
     
          <Button 
          label="Cloturer la demande de dépense"
          onClick={handleClose}
          style="green" //eslint-disable-line
          disabled={setCloseSingleSpending.isPending}
        />
       
        {setCloseSingleSpending.isPending && <p style={{margin: 0}}>Clôture en cours...</p>}
        <Button 
          label="Créer une dépense"
          onClick={handleNavigateToCreateSpending}
          style="gray" //eslint-disable-line
        />

        {isComptable && (
          <Button 
            label="Créer une avance"
            onClick={handleNavigateToCreateCredit}
            style="gray" //eslint-disable-line
          />
        )}
      </div>
      {errorMessage && (
        <div style={{ 
          color: '#d32f2f', 
          backgroundColor: '#ffebee', 
          padding: '12px', 
          borderRadius: '4px',
          fontSize: '14px',
          border: '1px solid #ffcdd2'
        }}>
          {errorMessage}
        </div>
      )}
    </div>
  )
}

/**
 * ActionUser - Groupe de boutons pour l'utilisateur
 * Contient: Annuler (désactivé si CREDITED ou VALIDATE), Créer une dépense (actif uniquement si VALIDATE ou CREDITED)
 */
export const ActionUser = () => {
  const {sendCancelSpendingDemand, singleSpendingDemandData} = useSingleSpendingDemand()
  const {userInfo} = useUserAuth()
  const {goToCreateSpendingFromDemandUser} = useNavigationApp()

  if (!userInfo?.user_id) {
    return <></>
  }

  if (!singleSpendingDemandData) {
    return <></>
  }

  // Vérifier que c'est bien l'utilisateur propriétaire de la demande
  if (userInfo?.user_id !== singleSpendingDemandData?.spending_demand_user?.user_id) {
    return <></>
  }

  // Ne pas afficher si déjà annulée
  if (singleSpendingDemandData?.spending_demand_status === "CANCELLED") {
    return <></>
  }

  // Ne pas afficher si REFUSED ou PAYED
  if (singleSpendingDemandData?.spending_demand_status === "REFUSED" || 
      singleSpendingDemandData?.spending_demand_status === "PAYED") {
    return <></>
  }

  const handleCancel = () => {
    sendCancelSpendingDemand.run({message: "Demande annulée"})
  }

  const handleNavigateToCreateSpending = () => {
    if (singleSpendingDemandData?.spending_demand_id) {
      goToCreateSpendingFromDemandUser(
        singleSpendingDemandData.spending_demand_id,
        singleSpendingDemandData.spending_demand_desc,
        singleSpendingDemandData.spending_demand_amount,
        singleSpendingDemandData.spending_demand_amountTTC,
        singleSpendingDemandData.spending_demand_desc
      )
    }
  }

  // Le bouton Annuler est désactivé si le statut est CREDITED ou VALIDATE
  const isCancelDisabled = 
    singleSpendingDemandData?.spending_demand_status === "CREDITED" ||
    singleSpendingDemandData?.spending_demand_status === "VALIDATE" ||
    singleSpendingDemandData?.spending_demand_status === "CLOSED" ||
    sendCancelSpendingDemand.isPending

    const canCancel = !isCancelDisabled
  // Le bouton Créer une dépense est actif uniquement si VALIDATE ou CREDITED
  const canCreateSpending = 
    singleSpendingDemandData?.spending_demand_status === "VALIDATE" ||
    singleSpendingDemandData?.spending_demand_status === "CREDITED"

  return (
    <div style={{display: "flex", gap: "10px"}}>

{canCancel && (
  <Button
    label="Annuler"
    onClick={handleCancel}
    disabled={isCancelDisabled}
    style="red" //eslint-disable-line
  />
)}

      {canCreateSpending && (
        <Button 
          label="Créer une dépense"
          onClick={handleNavigateToCreateSpending}
          style="gray" //eslint-disable-line
        />
      )}
      <ModifySpendingDemandBtnUser />
    </div>
  )
}

export const ActionBtnSpending = ({usertype}: {usertype: 'user' | 'compta' | 'admin' })=> {

  if (usertype === 'user') {
    return <ActionUser />
  }

  if (usertype === 'compta') {
    return <ActionComptaUser />
  }

  if (usertype === 'admin') {
    return <ActionComptaUser />
  }

  return <></>
}